<template>
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-6">About Us</h1>
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8">
      <p class="text-gray-700 dark:text-gray-300 mb-4">
        With years of experience in the transportation industry, we've built a reputation for reliability,
        efficiency, and exceptional customer service.
      </p>
      <p class="text-gray-700 dark:text-gray-300 mb-4">
        Our mission is to provide innovative transportation solutions that help our clients succeed
        in today's competitive business environment.
      </p>
    </div>
  </div>
</template>

<script setup>
useSeoMeta({
  title: 'About Us | Company Name',
  description: 'Learn about our company history, mission, and values.'
})
</script>